import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { Box, Button, Grid, Text, Icon } from "@chakra-ui/react";
import { AiFillCheckCircle } from "react-icons/ai";

const SUCCESS_TIME_OUT_DURATION = 3000;

const Success = ({ onComplete, hideExitButtons }) => {
  useEffect(() => {
    let onSuccessTimeout = null;
    if (hideExitButtons) {
      onSuccessTimeout = setTimeout(() => {
        onComplete();
      }, SUCCESS_TIME_OUT_DURATION);
    }
    return () => {
      clearTimeout(onSuccessTimeout);
    };
  }, [hideExitButtons, onComplete]);
  return (
    <Box mr="12" ml="12">
      <Grid gridTemplateRows="125px 1fr 1fr" gridGap="4" alignItems="center" textAlign="center">
        <Icon as={AiFillCheckCircle} w="100%" h="100%" color="integrator.500" />
        <Text fontWeight="bold" color="primaryText">
          <FormattedMessage defaultMessage="Success!" description="Status message" />
        </Text>
        <Text>
          <FormattedMessage
            defaultMessage="We received your request. We'll send you an email when the funds land in your USD wallet."
            description="Infromative message"
          />
        </Text>
      </Grid>
      {!hideExitButtons ? (
        <Box mt="12">
          <Button w="100%" onClick={onComplete}>
            <FormattedMessage defaultMessage="Close" description="Button label" />
          </Button>
        </Box>
      ) : null}
    </Box>
  );
};

export default Success;
